import { Component, OnInit, Input,ViewChild } from '@angular/core';
import { SearchComponent } from '../search/search.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rss-feed',
  templateUrl: './rss-feed.component.html',
  styleUrls: ['./rss-feed.component.css']
})
export class RssFeedComponent implements OnInit {
  hits_export: any[] = [];
  //@ViewChild('searchComponent',{static: false}) public first: SearchComponent;

  constructor(private router: Router) {
    //console.log(this.router.getCurrentNavigation().extras.state.hits_export);
  }

  nGetRssFeedo($event): void
  {    
    console.log('In nGetRssFeedo');
    //this.hits=$event;
    console.log($event);
  }

  ngOnInit() {
    //console.log(this.first.hits);
   // alert(this.first.name);
  }
}
